module.exports = __webpack_public_path__ + "static/media/0004.fec12ad0.jpg";